<template>
    <rkm-form
        ref="Form"
        :show-legend="showLegend"
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-input-autocomplete
                    :disabled="!tipoExameId"
                    :request-query-string-params="autocompletesRequestParams.exame.queryString"
                    :repository="repositories.exame"
                    :searchFields="fields.autocompletes.exame"
                    :text-field="e => `${e.codigo} - ${e.nome}`"
                    :validations="validations.exame"
                    label="Exame"
                    v-model="model.exame"
                />
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-button
                    :disabled="!tipoExameId"
                    :label="false"
                    color="primary"
                    @click.stop="$refs.Form.validate(add)"
                >
                    Incluir
                </rkm-button>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { repository, object } from '@/mixins'

export default {
    computed: {
        autocompletesRequestParams() {

            return {
                exame: {
                    queryString: { tipo_id: this.tipoExameId }
                }
            }
        },
        fields() {

            return {
                autocompletes: {
                    exame: [
                        { key: 'codigo', searchable: true },
                        { key: 'nome', searchable: true }
                    ],
                }
            }
        },
        validations() {

            return {
                exame: { required: true },
            }
        },
    },
    created() {

        this.repositories = {
            exame: this.getConectaSusRepository('parametrizacao.exame'),
        }

        this.initial.model = this.clone(this.model)
    },
    data: () => ({
        initial: {
            model: {}
        },
        model: {
            exame: null,
        },
    }),
    methods: {
        add() {

            if (this.itens.find(i => i.exame.id === this.model.exame.id)) {

                this.showValidationNotification('Este exame já foi incluído para este kit!')

                return
            }

            this.itens.push(this.clone(this.model))

            this.resetForm()
        },
        resetForm() {

            this.model = this.clone(this.initial.model)

            this.$refs.Form.resetValidator()
        }
    },
    mixins: [repository, object],
    props: {
        tipoExameId: { type: Number },
        itens: { type: Array, default: () => [] },
        showLegend: { type: Boolean, default: false },
    },
    watch: {
        tipoExameId() {

            this.model.exame = null
        }
    }
}
</script>